import { createAction } from 'redux-actions';

export const resetReservationsOrderItems = createAction(
  'RESET_RESERVATIONS_ORDER_ITEMS'
);
